import { IonToast } from '@ionic/react';
import { useContext } from 'react';
import { useIntl } from 'react-intl';

import styles from '@components/AppUpdatedToast.module.css';
import { appUpdatedContext } from '@context/Contexts';

const AppUpdatedToast = () => {
  const intl = useIntl();

  const { appUpdatedState } = useContext(appUpdatedContext);

  return (
    <IonToast
      buttons={[
        {
          handler: () => {
            window.location.reload();
          },
          side: 'end',
          text: intl.formatMessage({ id: 'pages.eventTracker.applyButton' })
        }
      ]}
      cssClass={styles.toast}
      isOpen={appUpdatedState}
      message={intl.formatMessage({ id: 'pages.eventTracker.applyUpdateMessage' })}
      position="top"
    />
  );
};

export default AppUpdatedToast;
